<template>
          <Echart
              :options="options"
              id='subjectchart'
              height="1.5rem"
              width="100%"></Echart>
</template>

<script>
 import Echart from '@/common/echart'
 // let Chart
export default {
  props: {
    item: Object,
    default:{
      value:0
    },
    range: String
  },
  components: {Echart},
  data () {
    return {
      options: {},
    };
  },
  watch:{
    item: {
      immediate: true,
      deep: true,
      handler(val) {
        var ll=val.allNum
        console.log(ll,'---')
          this.options = {
            tooltip: {
              trigger: 'item',
              show:false,
            },
            series: [
              {
                type: 'pie',
                radius: ['60%', '90%'],  // 放大图形
                center: ['50%', '50%'], // 往下移动  套住75%文字
                itemStyle: { // 颜色渐变#00c9e0->#005fc1
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: '#00c9e0' },
                      { offset: 1, color: '#005fc1' }
                    ]
                  }
                },
                startAngle: 180,
                hoverOffset: 0,  // 鼠标经过不变大
                data: [val, {value:val.allNum-val.value, itemStyle: { color: '#12274d'}}]
              },
            ]
          };
          this.options.series[0].data[0].label={
            show: true,
            position: 'center',
            formatter:function (params){

              let sum =  parseInt(params.value)
              let max =  parseInt(params.data.allNum)
              let val=(sum/max).toFixed(2)*100

              return  val+'%'

            },
            fontSize:24,
            color: '#fff',
        }
        // Chart = this.$echarts.init(document.getElementById('subjectchart'))
        // Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
      },

    },
    range:{
      immediate: false,
      deep: true,
      handler(val) {
        console.log(val,'11')
      }
    }
  },
  mounted() {
  },
  methods: {
    // drawLine:function (){
    //   //基于准备好的dom，初始化echarts实例
    //   Chart = this.$echarts.init(document.getElementById('subjectchart'))
    //   Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
    //   // option && myChart.setOption(option);
    // },
  },

};
</script>

<style lang="scss" scoped>
</style>